import { categoryTypeOf, filterByProgramType } from './enrollSequence';

export function ymd(value) {
  if (!value) return '';
  return String(value).split('T')[0];
}

export function locationForMode(mode, location) {
  return String(mode || '')
    .trim()
    .toLowerCase() === 'online'
    ? ''
    : String(location || '').trim();
}

export function batchMatchesEnrollment(batch, fields = {}) {
  if (!batch || !fields.courseId || !fields.modeOfCourse || !fields.batchStartDate) {
    return false;
  }
  if (String(batch.courseId) !== String(fields.courseId)) return false;
  if (String(batch.mode || '').trim() !== String(fields.modeOfCourse || '').trim()) {
    return false;
  }
  if (
    locationForMode(batch.mode, batch.location) !==
    locationForMode(fields.modeOfCourse, fields.locationOfCenter)
  ) {
    return false;
  }
  return ymd(batch.startDate) === ymd(fields.batchStartDate);
}

export function listMatchingBatches(batches, fields) {
  return (batches || []).filter((batch) => batchMatchesEnrollment(batch, fields));
}

/**
 * Keep the batch already selected when it still matches. If several batches
 * share the combo, do not guess the first one.
 */
export function matchingBatchId(batches, fields, preferredId) {
  const matches = listMatchingBatches(batches, fields);
  const preferred = String(preferredId || '');
  if (preferred && matches.some((batch) => String(batch.id) === preferred)) {
    return preferred;
  }
  if (matches.length === 1) return String(matches[0].id);
  return '';
}

function categoryIdOfCourse(course) {
  if (!course || typeof course !== 'object') return '';
  if (course.categoryId != null && course.categoryId !== '') return String(course.categoryId);
  if (course.category && typeof course.category === 'object') {
    const id = course.category.id ?? course.category.categoryId;
    return id != null ? String(id) : '';
  }
  return '';
}

/**
 * Apply an editable enroll-field change and keep course / category / program in sync.
 */
export function applyEnrollFieldChange({
  field,
  value,
  formData,
  courses = [],
  batches = [],
} = {}) {
  const next = {
    courseId: formData.courseId || '',
    courseCategoryId: formData.courseCategoryId || '',
    programType: formData.programType || '',
    modeOfCourse: formData.modeOfCourse || '',
    locationOfCenter: formData.locationOfCenter || '',
    batchStartDate: formData.batchStartDate || '',
    courseCompletionDate: formData.courseCompletionDate || '',
    [field]: value,
  };

  if (field === 'programType') {
    const allowed = filterByProgramType(courses, value);
    if (!allowed.some((course) => String(course.id) === String(next.courseId))) {
      next.courseId = '';
      next.courseCategoryId = '';
    }
  }

  if (field === 'courseId') {
    const course = (courses || []).find((row) => String(row.id) === String(value));
    next.courseCategoryId = categoryIdOfCourse(course);
    const type = categoryTypeOf(course);
    if (type) next.programType = type;
  }

  if (field === 'modeOfCourse' && String(value).trim().toLowerCase() === 'online') {
    next.locationOfCenter = '';
  }

  next.batchId = matchingBatchId(batches, next, formData.batchId) || '';
  return next;
}
